module.exports = function (app) {
	'use strict';
	app.controller('pages.employee.add.coverage', ['$state', '$scope', 'employee', '$q',
		function ($state, $scope, employee, $q) {

			if (!($state.params.subscriberSSN || $state.params.PCPNumber)) {
				$state.go('employee.add.subscriber');
				return;
			}

			$scope.employee = employee;
			employee.loadEnrollment( $state.params.subscriberSSN );

			var deferred;

			$scope.setPlanCoverage = function() {
				deferred = $q.defer();
				$scope.$broadcast('assignPlans');
				return deferred.promise;
			};

			$scope.$on('plansAssigned', function(eggs, isSuccessful) {
				console.debug('heard plansAssigned');
				if (isSuccessful) {
					$scope.$broadcast('assignAct4');
					$scope.$broadcast('assignProviders');
                    $scope.$broadcast('assignTobacco');
				}
				else { deferred.reject('lol nah'); }
			});

			$scope.$on('providersAssigned', function(event, isSuccessful) {
				console.debug('heard providersAssigned', isSuccessful);
				if (isSuccessful) {
					$scope.$broadcast('validateReportCodes');
				}
				else { deferred.reject('invalid provider'); }
			});

			$scope.$on('reportCodesValidated', function(event, isSuccessful) {
				console.debug('heard reportCodesValidated', isSuccessful);
				if (isSuccessful) {
					deferred.resolve();
				}
				else { deferred.reject('invalid report codes'); }
			});

			$scope.$on('medicalPlanUpdated', function(event, additionalGroupInformation, plan, optInObj, groupNumber, productEffectiveDate) {
				console.debug('heard medicalPlanUpdated');
				$scope.additionalGroupInformation = additionalGroupInformation;
				$scope.additionalGroupInformationGroup = groupNumber;
				$scope.productEffectiveDate = productEffectiveDate;
			});
			$scope.reportCodeGroups = [];
			var reportCodeHash = {};
			$scope.$on('planChanged', function(event, product, plan) {
				if (plan) {
					if (reportCodeHash[product]) {
						var index = $scope.reportCodeGroups.indexOf(reportCodeHash[product]);
						if (index != -1) {
							$scope.reportCodeGroups.splice(index,1);
						}
					}
					$scope.reportCodeGroups.push(plan.groupNumber);
					reportCodeHash[product] = plan.groupNumber;
					$scope.hasReportCodes = $scope.reportCodeGroups.length > 0;
				}
				else {
					var index = $scope.reportCodeGroups.indexOf(reportCodeHash[product]);
					if (index != -1) {
						$scope.reportCodeGroups.splice(index,1);
					}
					$scope.hasReportCodes = $scope.reportCodeGroups.length > 0;
				}
			});
		}
	]);
};
